import { Link } from "wouter";
import { ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";

const RefundPolicyPage = () => {
  return (
    <div className="min-h-screen bg-background">
      <header className="border-b border-border px-6 py-4">
        <div className="mx-auto flex max-w-4xl items-center gap-3">
          <Link href="/">
            <Button variant="ghost" size="sm" data-testid="button-back">
              <ArrowLeft className="mr-2 h-4 w-4" />
              Back to HiPo AI Coach
            </Button>
          </Link>
        </div>
      </header>

      <main className="mx-auto max-w-4xl px-6 py-12">
        <div className="prose prose-zinc dark:prose-invert max-w-none">
          <h1>REFUND POLICY</h1>
          <p><em>Updated at January 17th, 2026</em></p>

          <h2>Definitions and key terms</h2>
          <p>To help explain things as clearly as possible in this Refund Policy, every time any of these terms are referenced, are strictly defined as:</p>
          <ul>
            <li><strong>Company:</strong> when this policy mentions “Company”, “we”, “us” or “our”, it refers to HiPo Career Solutions, that is responsible for your information under this Refund Policy.</li>
            <li><strong>Customer:</strong> refers to the company, organization or person that signs up to use the HiPo AI Coach Service of HiPo Career Solutions to manage the relationships with your consumers or service users.</li>
            <li><strong>Device:</strong> any internet connected device such as a phone, tablet, computer or any other device that can be used to visit HiPo AI Coach of HiPo Career Solutions and use the services.</li>
            <li><strong>Service:</strong> refers to the service provided by HiPo AI Coach of HiPo Career Solutions as described in the relative terms (if available) and on this platform.</li>
            <li><strong>Website:</strong> HiPo AI Coach of HiPo Career Solutions’s site, which can be accessed via this URL: hipoaicoach.com</li>
            <li><strong>You:</strong> a person or entity that is registered with HiPo AI Coach of HiPo Career Solutions to use the Services.</li>
          </ul>

          <h2>Refund Policy</h2>
          <p>Thanks for shopping at HiPo AI Coach of HiPo Career Solutions. We appreciate the fact that you like to buy the stuff we create. We also want to make sure you have a rewarding experience while you’re exploring, evaluating, and purchasing our products.</p>
          <p>As with any shopping experience, there are terms and conditions that apply to transactions at HiPo AI Coach of HiPo Career Solutions. We’ll be as brief as our attorneys will allow. The main thing to remember is that by placing an order or making a purchase at HiPo AI Coach of HiPo Career Solutions, you agree to the terms set forth below along with HiPo AI Coach’s Privacy Policy.</p>
          <p>If you choose not to continue post your purchase either due to quality of experience or quality of service, you will not be able to issue a refund for your subscription.</p>

          <h2>Refunds</h2>
          <p>We at HiPo Career Solutions commit ourselves to serving our customers with the best digital products, services and experiences. Every single product that you choose is tested and shared with you. We do this to ensure that you fall in love with our products.</p>
          <p>Sadly, there are times when our systems and servers might cause issues. In such cases, we may have to cancel your order. You will be intimated about it in advance so that you don't have to worry unnecessarily about your order.</p>
          <p>The following are our policy on refunds on subscriptions or services purchased on our webapp:</p>
          <ul>
            <li>Refunds are NOT given for any purchases made.</li>
            <li>If you face any issues, please write to us on the email ID shared below.</li>
          </ul>

          <h2>Your Consent</h2>
          <p>By using our website, registering an account, or making a purchase, you hereby consent to our Refund Policy and agree to its terms.</p>

          <h2>Changes To Our Refund Policy</h2>
          <p>Should we update, amend or make any changes to this document so that they accurately reflect our Service and policies. Unless otherwise required by law, those changes will be prominently posted here. Then, if you continue to use the Service, you will be bound by the updated Refund Policy. If you do not want to agree to this or any updated Refund Policy, you can delete your account.</p>

          <h2>Contact Us</h2>
          <p>If, for any reason, You are not completely satisfied with any good or service that we provide, don't hesitate to contact us and we will discuss any of the issues you are going through with our product.</p>
          <ul>
            <li>Via Email: <a href="mailto:contactus@hipo.co.in">contactus@hipo.co.in</a></li>
          </ul>
        </div>
      </main>
    </div>
  );
};

export default RefundPolicyPage;
